module.exports = __webpack_public_path__ + "static/img/gif.0df49b4b.png";